<td class="group-list-row__group">
  <div class="group-list-row__name-line">
    @if (canUpdate()) {
      <a class="group-list-row__name" [routerLink]="editLink()">{{ row().group.name }}</a>
    } @else {
      <span class="group-list-row__name group-list-row__name--plain">{{ row().group.name }}</span>
    }
    @if (row().isDefault) {
      <span
        class="group-list-row__default"
        title="Criado e mantido pela plataforma: não pode ser excluído">
        Padrão
      </span>
    }
  </div>
  @if (row().modulesText) {
    <p class="group-list-row__modules" [title]="row().modulesText">{{ row().modulesText }}</p>
  }
</td>
<td>
  <span class="group-list-row__role" [attr.data-tone]="row().roleTone">{{ row().roleLabel }}</span>
</td>
<td>
  <div class="group-list-row__perms">
    <span class="group-list-row__perms-total">{{ row().total }}</span>
    <div class="group-list-row__perms-detail">
      <div class="group-list-row__bar" aria-hidden="true">
        <span class="group-list-row__bar-read" [style.width.%]="row().readPercent"></span>
        <span class="group-list-row__bar-write" [style.width.%]="row().writePercent"></span>
      </div>
      <p class="group-list-row__breakdown">{{ row().breakdown }}</p>
    </div>
  </div>
</td>
<td class="group-list-row__users">
  @if (row().usersCount !== null) {
    <span class="group-list-row__users-count" [attr.aria-label]="usersText()" [title]="usersText()">
      <i class="pi pi-users" aria-hidden="true"></i><span>{{ row().usersCount }}</span>
    </span>
  } @else {
    <span class="group-list-row__users-missing" title="Contagem indisponível">—</span>
  }
</td>
<td class="group-list-row__actions">
  @if (menuItems().length) {
    <app-button-menu
      class="group-list-row__menu"
      icon="ellipsis-h"
      theme="white"
      size="small"
      [showChevron]="false"
      [items]="menuItems()"
      [title]="'Ações do grupo ' + row().group.name" />
  }
</td>
